let router

if (process.env.VUE_APP_BUILD_TARGET !== 'app') {
  router = require('./web')
} else {
  router = require('./app')
}

export default router.default
